import { AutogenLayoutLaneBuilderResultsSlideout } from "./autogen/AutogenLayoutLaneBuilderResultsSlideout";
import { TableSelectionEvent,  TableRowDisplayEvent, Label, DataSourceMode } from "@mcleod/components";
import { Api, ModelRow } from "@mcleod/core";
export class LaneBuilderResultsSlideout extends AutogenLayoutLaneBuilderResultsSlideout {

    /** This is an event handler for the onSelect event of tableCarriers. */
    async tableCarriersOnSelect(event: TableSelectionEvent) {
        const data = event.newRow?.data as ModelRow;
        if(!data) return;

        //lanes
        const laneData = data?.get("carrier_lanes");
        const lanes = [];
        for (const lane of laneData) {
            //the model at this path is just used to define db/display value metadata. this allows us to use that
            lanes.push(new ModelRow("lme/powerbroker/pnn-builder-lane", false, { ...lane })); 
        }
        
        this.sourcePnnBuilderLane.setRowsAndMode(DataSourceMode.NONE, lanes);

        //contacts
        const contactData = data?.get("carrier_contacts");
        const contacts = [];
        for (const contact of contactData) {
            //the model at this path is just used to define db/display value metadata. this allows us to use that
            contacts.push(new ModelRow("lme/powerbroker/pnn-builder-sendto", false, { ...contact })); 
        }

        this.sourcePnnBuilderSendto.setRowsAndMode(DataSourceMode.NONE, contacts);
    }

    /** This is an event handler for the onRowDisplay event of tableContacts. */
    tableContactsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow()
        const laneLabel = tableRow.findComponentById("labelLaneNumbers") as Label
        laneLabel.text = laneLabel.text.replace(/[\[\]]/g, "");

        if (tableRow.data?.getBoolean("new", false)) tableRow.backgroundColor = "success.lightest";
        else if (tableRow.data?.getBoolean("updated", false)) tableRow.backgroundColor = "primary.lightest";
    }

    /** This is an event handler for the onRowDisplay event of tableLanes. */
    tableLanesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow()

        if (tableRow.data?.getBoolean("new", false)) tableRow.backgroundColor = "success.lightest";
        else if (tableRow.data?.getBoolean("updated", false)) tableRow.backgroundColor = "primary.lightest";
    }

    async postChanges(id: String) {
        await Api.update("lme/powerbroker/pnn-lane-builder", { profile_id: id });
    }

}
